export const AppsFlyerIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='56'
    height='16'
    viewBox='0 0 56 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='download 1'>
      <path
        id='Vector'
        d='M0.0718009 5.06874L2.50451 9.58374C2.67312 9.89762 3.08258 10.1391 3.41979 10.1391H8.38156C8.71876 10.1391 8.86328 9.89762 8.69468 9.58374L6.23788 5.04458C6.06928 4.7307 5.6598 4.48926 5.3226 4.48926H0.360836H0.33675C0.0477145 4.51342 -0.0968031 4.75486 0.0718009 5.06874Z'
        fill='#7AD143'
      />
      <path
        id='Vector_2'
        d='M9.4906 10.3092L10.9599 12.9892C11.0562 13.1823 11.2971 13.3272 11.5138 13.3272L14.4524 13.2789C14.6451 13.2789 14.7414 13.1341 14.6451 12.9409L13.1758 10.2609C13.0795 10.0677 12.8386 9.92285 12.6218 9.92285L9.6592 9.94701C9.46652 9.99529 9.3702 10.1401 9.4906 10.3092Z'
        fill='#7AD143'
      />
      <path
        id='Vector_3'
        d='M9.49009 0.168034L6.55157 3.86212C6.35885 4.10354 6.33477 4.5623 6.50337 4.87618L8.96017 9.36702C9.12877 9.6809 9.41781 9.72918 9.63461 9.46362L12.5972 5.7695C12.7899 5.52806 12.814 5.06934 12.6454 4.75546L10.1645 0.264611C10.0682 0.095601 9.92365 -0.000976562 9.77913 -0.000976562C9.68277 -0.000976562 9.58641 0.0473122 9.49009 0.168034Z'
        fill='#00C2FF'
      />
      <path
        id='Vector_4'
        d='M8.81468 10.3581L7.05636 12.5552C6.93596 12.7001 6.91188 12.9657 7.03228 13.1588L8.50156 15.8389C8.59788 16.032 8.7906 16.0562 8.91104 15.8871L10.6693 13.69C10.7898 13.5451 10.8138 13.2796 10.6934 13.0864L9.22416 10.4064C9.17596 10.3098 9.07964 10.2374 9.00736 10.2615C8.91104 10.2615 8.86284 10.2857 8.81468 10.3581Z'
        fill='#00C2FF'
      />
      <path id='Vector_5' d='M42.054 3.91113H41.0664V11.1303H42.054V3.91113Z' fill='#00C2FF' />
      <path
        id='Vector_6'
        d='M23.4125 6.2041C21.9914 6.2041 20.8594 7.31474 20.8594 8.69098V13.3025H21.8469V8.69098C21.8469 7.8459 22.5454 7.14574 23.4366 7.14574C24.3037 7.14574 25.0263 7.8459 25.0263 8.69098C25.0263 9.53602 24.3278 10.2362 23.4366 10.2362C22.9549 10.2362 22.4973 10.0189 22.2082 9.6809V10.8881C22.5695 11.0813 22.979 11.1778 23.4125 11.1778C24.8336 11.1778 25.9657 10.0672 25.9657 8.69098C25.9657 7.31474 24.8336 6.2041 23.4125 6.2041Z'
        fill='#7AD143'
      />
      <path
        id='Vector_7'
        d='M28.975 6.2041C27.5539 6.2041 26.4219 7.31474 26.4219 8.69098V13.3025H27.4094V8.69098C27.4094 7.8459 28.1079 7.14574 28.9991 7.14574C29.8662 7.14574 30.5888 7.8459 30.5888 8.69098C30.5888 9.53602 29.8903 10.2362 28.9991 10.2362C28.5174 10.2362 28.0598 10.0189 27.7707 9.6809V10.8881C28.132 11.0813 28.5415 11.1778 28.975 11.1778C30.3961 11.1778 31.5282 10.0672 31.5282 8.69098C31.5282 7.31474 30.372 6.2041 28.975 6.2041Z'
        fill='#7AD143'
      />
      <path
        id='Vector_8'
        d='M17.7016 3.91113C16.2805 3.91113 15.1484 5.02178 15.1484 6.39798V11.1303H16.136V6.42214C16.136 5.5771 16.8345 4.90106 17.7016 4.90106C18.5687 4.90106 19.2672 5.5771 19.2672 6.42214V6.9533H16.7381V7.91911H19.2672V11.1544H20.2547V6.42214C20.2547 5.02178 19.0986 3.91113 17.7016 3.91113Z'
        fill='#7AD143'
      />
      <path
        id='Vector_9'
        d='M37.7688 6.42145C37.7688 5.57637 38.4673 4.90033 39.3344 4.90033H40.5868V3.93457H39.3344C37.9133 3.93457 36.7812 5.04521 36.7812 6.42145V11.1537H37.7688V8.01497H40.4904V7.04921H37.7688V6.42145Z'
        fill='#00C2FF'
      />
      <path
        id='Vector_10'
        d='M46.1746 6.22754V9.24558C46.1506 9.84918 45.6446 10.3321 45.0186 10.3321C44.3922 10.3321 43.8866 9.84918 43.8622 9.24558V6.22754H42.875V9.24558C42.875 10.2113 43.5734 11.0323 44.5126 11.2496V13.3018H45.5002V11.2496C46.4398 11.0323 47.1382 10.2355 47.1382 9.24558V6.22754H46.1746Z'
        fill='#00C2FF'
      />
      <path
        id='Vector_11'
        d='M51.7147 9.07662C51.6183 9.46294 51.3531 9.80094 50.9679 10.0183C50.2211 10.4529 49.2579 10.1873 48.8243 9.46294C48.3907 8.73858 48.6555 7.79698 49.4023 7.36238C50.0043 7.02434 50.7511 7.12094 51.2327 7.55554L49.0167 8.81102L49.4987 9.63194L52.5815 7.89354C52.5335 7.74866 52.4611 7.60382 52.3891 7.45894C51.6903 6.27586 50.1247 5.86542 48.8963 6.54146C47.6679 7.24166 47.2587 8.76274 47.9571 9.94582C48.6555 11.1289 50.2211 11.5393 51.4495 10.8633C52.1479 10.477 52.5815 9.80094 52.7019 9.07662H51.7147Z'
        fill='#00C2FF'
      />
      <path
        id='Vector_12'
        d='M55.8071 6.2041C55.2047 6.2041 54.6747 6.39722 54.2415 6.73526V6.22822H53.2539V11.1537H54.2415V8.69094C54.2415 7.8459 54.9399 7.16986 55.8071 7.16986H55.9995V6.2041H55.8071Z'
        fill='#00C2FF'
      />
      <path
        id='Vector_13'
        d='M35.2615 8.86036L32.8047 7.74972C32.6843 7.70144 32.6361 7.55656 32.6843 7.43584C32.7324 7.33928 32.8047 7.291 32.901 7.291H35.6951V6.3252H32.901C32.4434 6.3252 31.9858 6.5908 31.7931 7.0254C31.504 7.629 31.769 8.3292 32.3711 8.61892L34.8279 9.72956C34.9484 9.77784 34.9965 9.92272 34.9484 10.0434C34.9002 10.14 34.8279 10.1883 34.7316 10.1883H31.8653V11.1541H34.7316C35.1892 11.1541 35.6469 10.8885 35.8396 10.4539C36.1527 9.85028 35.8877 9.15012 35.2615 8.86036Z'
        fill='#7AD143'
      />
    </g>
  </svg>
);
